import { REWARD_IDS } from '../../constants';
import '../../css/SpinEventRewardDetailModal.css';
import { useNavigate } from 'react-router-dom';

const SpinEventRewardDetailModal = ({ onClose, isOpen, selectedRewardId }) => {
	const navigate = useNavigate();
	if (!isOpen || !selectedRewardId) return null;

	const rewardModalContent = [
		{
			id: REWARD_IDS.TNG_RM3,
			imgSrc: '/spin-event/haleon-tng3.png',
			type: "Touch'n Go eWallet PIN",
		},
		{
			id: REWARD_IDS.TNG_RM5,
			imgSrc: '/spin-event/haleon-tng5.png',
			type: "Touch'n Go eWallet PIN",
		},
		{
			id: REWARD_IDS.TNG_RM10,
			imgSrc: '/spin-event/haleon-tng10.png',
			type: "Touch'n Go eWallet PIN",
		},
		{
			id: REWARD_IDS.POINTS_20,
			imgSrc: '/spin-event/haleon-20-points.png',
			type: 'Points',
		},
		{
			id: REWARD_IDS.POINTS_70,
			imgSrc: '/spin-event/haleon-70-points.png',
			type: 'Points',
		},
		{
			id: REWARD_IDS.POINTS_120,
			imgSrc: '/spin-event/haleon-120-points.png',
			type: 'Points',
		},
	];

	const selectedReward = rewardModalContent.find(
		(reward) => reward.id === selectedRewardId
	);

	return (
		<div className="reward-modal-overlay">
			<div className="reward-modal-backdrop" onClick={onClose} />

			<div className="reward-modal-content">
				<div className="reward-decoration-section">
					<svg
						onClick={onClose}
						style={{
							zIndex: 100,
							cursor: 'pointer',
							position: 'absolute',
							top: '1rem',
							right: '1rem',
						}}
						className="vector"
						width="12"
						height="12"
						viewBox="0 0 12 12"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M0.923077 12L0 11.0769L5.07692 6L0 0.923077L0.923077 0L6 5.07692L11.0769 0L12 0.923077L6.92308 6L12 11.0769L11.0769 12L6 6.92308L0.923077 12Z"
							fill="black"
						/>
					</svg>
					<img
						src="/spin-event/top-left-balloon.png"
						alt="Balloon decoration"
						className="reward-decoration-tl-balloon"
					/>
					<img
						src="/spin-event/bottom-left-balloon.png"
						alt="Balloon decoration"
						className="reward-decoration-bl-balloon"
					/>
					<img
						src="/spin-event/bottom-right-balloon.png"
						alt="Balloon decoration"
						className="reward-decoration-br-balloon"
					/>
					<img
						src="/spin-event/top-right-balloon.png"
						alt="Balloon decoration"
						className="reward-decoration-rt-balloon"
					/>
					<img
						src="/spin-event/flag-banner-left.png"
						alt="Left banner"
						className="reward-decoration-flag-left"
					/>
					<img
						src="/spin-event/flag-banner-right.png"
						alt="Right banner"
						className="reward-decoration-flag-right"
					/>
					<img
						src="/spin-event/confetti-1.png"
						alt="Confetti"
						className="reward-decoration-confetti"
					/>
					<img
						src="/spin-event/confetti-2.png"
						alt="Confetti"
						className="reward-decoration-confetti"
					/>
					{selectedReward && (
						<div className="reward-image-container">
							<div>
								<h1>Congratulations!</h1>
								<h2 style={{ textAlign: 'center' }}>You have won</h2>
							</div>
							<img
								src={selectedReward.imgSrc}
								alt={selectedReward.type}
								style={{
									scale:
										selectedReward.id === REWARD_IDS.TNG_RM10 ||
										selectedReward.id === REWARD_IDS.POINTS_20
											? '0.75'
											: '1.5',
									maxWidth: '150px',
									objectFit: 'contain',
								}}
								// className="reward-image"
							/>
							{selectedReward.type !== 'Points' && <p>{selectedReward.type}</p>}
						</div>
					)}
				</div>

				<div className="reward-text-content">
					<button
						onClick={() =>
							selectedReward.type === 'Points'
								? navigate('/submissions', { state: { activeTab: 'Points' } })
								: navigate('/rewards')
						}
						className="check-reward-button"
					>
						Check My Rewards
					</button>
					<button onClick={onClose} className="back-to-home-button">
						Back to Home
					</button>

					<div className="reward-terms-container">
						<p className="reward-terms-text">
							Reward will be credited to your account.{' '}
							<span
								onClick={() => window.open('https://www.google.com', '_blank')}
								className="reward-terms-link"
							>
								T&Cs apply
							</span>
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SpinEventRewardDetailModal;
